import { render, staticRenderFns } from "./MedecinDetailFpregradedit.vue?vue&type=template&id=fb3195c8&"
import script from "./MedecinDetailFpregradedit.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailFpregradedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports